import React from 'react';

import InfoBlock from 'RLX/Controllers/InfoBlock';
import PaneController from 'RLX/Controllers/PaneController';

import AssetsListView from './AssetsListView'

class AssetsPane extends PaneController {
  renderIndex () {
    return <AssetsListView />
  }
}

export default AssetsPane;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Panes/Assets/AssetsPane.jsx